import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/uber/menu';
const sync = (systemSource, merchantId, branchId, operateBy) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/${branchId}/upload`
		),
		{},
		{
			operateBy,
		}
	);
};

const syncLogs = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/${branchId}/uploadMenuRecords`
		)
	);
};

export default {
	sync,
	syncLogs,
};
